module.exports = __webpack_public_path__ + "static/michael_farid-0cf0cecc6ae219c086a04ba26db821e4.png";